"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAP_DEFAULT_OPTIONS = void 0;
exports.MAP_DEFAULT_OPTIONS = {
    required: 'atLeastOnce',
    hidden: false,
    key: false,
    savedAs: undefined,
    defaults: {
        key: undefined,
        put: undefined,
        update: undefined
    },
    links: {
        key: undefined,
        put: undefined,
        update: undefined
    },
    validators: {
        key: undefined,
        put: undefined,
        update: undefined
    }
};
